var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L11 0L11 11L0 11L0 0Z",
    id: "Background",
    fill: "#DB5565",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13949 0.0810962C3.26978 0.137728 3.24069 0.22345 3.19767 0.626374C3.15342 1.04384 3.00642 1.8042 2.72265 2.55063C2.43856 3.29799 2.01706 4.03142 1.64973 4.57515C1.28301 5.11827 0.968595 5.47137 0.729378 5.67499C0.488923 5.87862 0.32274 5.93278 0.214118 5.95135C0.106424 5.96991 0.0575284 5.95135 0.0284386 5.89719C-0.000651156 5.84303 -0.0108635 5.75174 0.0142032 5.64374C0.038651 5.5345 0.0971399 5.40762 0.263013 5.24546C0.430434 5.08237 0.704311 4.88338 1.0865 4.69708C1.46869 4.51171 1.95796 4.33934 2.35995 4.22205C2.76195 4.10415 3.07513 4.04102 3.34931 3.9915C3.62412 3.94168 3.859 3.90547 4.08894 3.88752C4.31949 3.86895 4.54509 3.86895 4.76543 3.88752C4.98577 3.90547 5.20146 3.94168 5.38776 3.98624C5.57375 4.03173 5.73065 4.0862 5.86774 4.17254C6.00453 4.25826 6.12243 4.37617 6.18092 4.50738C6.24034 4.6389 6.24034 4.78373 6.19113 4.88771C6.14224 4.99169 6.04383 5.05544 5.93149 5.09103C5.81916 5.12724 5.69166 5.13621 5.53971 5.09103C5.38776 5.04585 5.21075 4.94651 5.02507 4.81468C4.83939 4.68378 4.64319 4.52131 4.3885 4.26755C4.13381 4.01378 3.82001 3.66904 3.55573 3.33451C3.29144 2.99936 3.07513 2.67349 2.92813 2.39745C2.78175 2.12109 2.70315 1.89487 2.6394 1.66804C2.57565 1.44182 2.52675 1.2156 2.50726 1.01197C2.48776 0.807721 2.49704 0.626684 2.51685 0.482782C2.53635 0.337334 2.56636 0.229021 2.61495 0.156606C2.66385 0.0838814 2.73286 0.0476739 2.78175 0.0297249C2.83065 0.011157 2.86036 0.011157 2.88945 0.00713396C2.91854 0.00280144 2.94763 -0.00648252 2.9925 0.00713396C3.03521 0.0195126 3.09215 0.0541727 3.13949 0.0810962L3.13949 0.0810962Z",
    transform: "translate(2.291748 2.520752)",
    id: "Shape",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.4d9aec9d9377664155b1e4d9ffc12ffb.svg";
export { ForwardRef as ReactComponent };